import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as fromSeriousSystem from '@serious-system';
import { NEW_CHAT_TITLE_DEFAULT } from './chats.constants';

@Injectable()
export class ChatsHelper {
  private readonly translateService = inject(TranslateService);

  public getChatTitle(chatTitle: string | undefined): string {
    if (!chatTitle || chatTitle === NEW_CHAT_TITLE_DEFAULT) {
      return this.translateService.instant(NEW_CHAT_TITLE_DEFAULT) as string;
    }

    return chatTitle;
  }

  public getChatDropdownMenuOptions(
    actions: {
      delete?: (() => void) | undefined;
      rename?: (() => void) | undefined;
    } = {},
  ): fromSeriousSystem.DropdownMenuOption[] {
    const options: fromSeriousSystem.DropdownMenuOption[] = [];

    if (actions.rename) {
      options.push({
        label: this.translateService.instant(
          'CHAT.DROPDOWN_MENU.RENAME',
        ) as string,
        icon: { type: 'uiBasic', icon: 'edit' },
        action: actions.rename,
      });
    }

    options.push({
      label: this.translateService.instant(
        'CHAT.DROPDOWN_MENU.DELETE',
      ) as string,
      icon: { type: 'uiBasic', icon: 'delete' },
      action: actions.delete,
      error: true,
    });

    return options;
  }

  public getChatDrawerOptions(
    {
      withAssistantProfile,
      withRename,
      withDelete,
    }: {
      withAssistantProfile: boolean;
      withRename: boolean;
      withDelete: boolean;
    } = {
      withAssistantProfile: false,
      withRename: true,
      withDelete: true,
    },
  ): fromSeriousSystem.OptionMenu[] {
    const options: fromSeriousSystem.OptionMenu[] = [];

    if (withAssistantProfile) {
      options.push({
        label: this.translateService.instant(
          'CHAT.DROPDOWN_MENU.ASSISTANT_PROFILE',
        ) as string,
        icon: { type: 'uiBasic', icon: 'folder-gear' },
        action: 'assistant-profile',
        error: false,
      });
    }
    if (withRename) {
      options.push({
        label: this.translateService.instant(
          'CHAT.DROPDOWN_MENU.RENAME',
        ) as string,
        icon: { type: 'uiBasic', icon: 'edit' },
        action: 'rename',
        error: false,
      });
    }
    if (withDelete) {
      options.push({
        label: this.translateService.instant(
          'CHAT.DROPDOWN_MENU.DELETE',
        ) as string,
        icon: { type: 'uiBasic', icon: 'delete' },
        action: 'delete',
        error: true,
      });
    }

    return options;
  }
}
